import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { NikoFacilityOrderListTemplate } from "themes/application/niko-facility-order/pages";
import { NikoFacilityOrderListViewStore } from "application/niko-facility-order/stores";

@setCurrentView(rootStore => new NikoFacilityOrderListViewStore(rootStore), "nikoFacilityOrderListViewStore")
@observer
class NikoFacilityOrderList extends React.Component {
    render() {
        return <NikoFacilityOrderListTemplate {...this.props} />;
    }
}

export default NikoFacilityOrderList;